import { FC, useEffect } from "react";
import { Loader } from "@/components";
import { useNavigate } from "react-router-dom";
import { useChallengeSlugForRedirect } from "@/features/challenge/hooks/useChallengeSlugForRedirect";
import FormErrorMessage from "@/components/FormErrorMessage/FormErrorMessage";
import { Heading } from "@radix-ui/themes";
import { siteRoutes } from "@/routes/siteRoutesList";

const ForzaMotorsportChallenge: FC = (): JSX.Element => {
  const navigate = useNavigate();

  const { data: slug, loading, error } = useChallengeSlugForRedirect("fm8");

  useEffect(() => {
    if (!loading && slug) {
      navigate(`${siteRoutes["challengesAndSlug"]}${slug}`);
    }
  }, [slug]);

  if (loading) {
    return (
      <Loader>
        <Heading>Looking for the challenge</Heading>
      </Loader>
    );
  }

  if (error) {
    return <FormErrorMessage isVisible text={error.message} />;
  }

  return null;
};

export default ForzaMotorsportChallenge;
